import { useEffect } from "react";
import ReactGA from "react-ga4";
import Navbar from "../components/Navbar";
import SanityBlock from "../components/SanityBlock";
import SEO from "../api/SEO";

export default function Landing(props) {
    const pageHeader = props.landingData.pageHeader;
    const pageSubheader = props.landingData.pageSubheader;
    const heroImageURL = props.landingData.heroImageURL;
    const heroImageAlt = props.landingData.heroImageAlt;
    const downloadCallToAction = props.landingData.downloadCallToAction;
    const aboutHeader = props.landingData.aboutHeader;
    const aboutBody = props.landingData.aboutBody;
    const aboutImages = props.landingData.screenshots;
    const aboutIOSCompatibility = props.landingData.aboutIOSCompatibility;
    const aboutAndroidCompatibility =
        props.landingData.aboutAndroidCompatibility;
    const callToActionHeader = props.landingData.callToActionHeader;
    const callToActionBody = props.landingData.callToActionBody;
    const appleUrl = props.landingData.appleUrl;
    const androidUrl = props.landingData.androidUrl;

    const seoPageTitle = props.landingData.seoPageTitle;
    const seoPageDescription = props.landingData.seoPageDescription;
    const seoPageAuthor = props.landingData.seoPageAuthor;
    const seoPageType = props.landingData.seoPageType;

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "Landing" });
    }, []);

    return (
        <>
            {seoPageTitle &&
                seoPageDescription &&
                seoPageAuthor &&
                seoPageType && (
                    <SEO
                        title={seoPageTitle}
                        description={seoPageDescription}
                        name={seoPageAuthor}
                        type={seoPageType}
                    />
                )}
            <div className="Landing-Hero-Background">
                <Navbar />
                <div className="Landing-Hero-Container">
                    <div className="Landing-Hero-Text-Column">
                        {pageHeader && (
                            <h1 className="Landing-Hero-Header-Text">
                                {pageHeader}
                            </h1>
                        )}
                        {pageSubheader && (
                            <h3 className="Landing-Hero-Subheader-Text">
                                {pageSubheader}
                            </h3>
                        )}
                        <div className="Landing-Hero-CTA-Container">
                            {downloadCallToAction && (
                                <h5 className="Landing-Hero-CTA-Text">
                                    {downloadCallToAction}
                                </h5>
                            )}
                            {appleUrl && (
                                <a href={appleUrl}>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/App-Store-Logos/Apple-App-Store-Badge_White.svg`}
                                        alt="Apple App Store Badge"
                                    />
                                </a>
                            )}
                            {androidUrl && <></>}
                        </div>
                        <div className="Wide-Spacer-6rem" />
                    </div>
                    <div className="Landing-Hero-Image-Column">
                        <img src={heroImageURL} alt={heroImageAlt} />
                    </div>
                </div>
            </div>
            <div className="Landing-About-Container">
                <div className="Landing-About-Text-Container">
                    {aboutHeader && (
                        <h2 className="Landing-About-Header-Text">
                            {aboutHeader}
                        </h2>
                    )}
                    {aboutBody && (
                        <div className="Landing-About-Body-Text">
                            <SanityBlock blocks={aboutBody} />
                        </div>
                    )}
                </div>
                {aboutImages && (
                    <div className="Landing-About-Screenshots-Container">
                        {aboutImages.map((image, index) => (
                            <div
                                key={index}
                                className="Landing-About-Screenshot-Container-Per"
                            >
                                <img
                                    src={image.screenshotURL}
                                    alt={image.altText}
                                />
                                <h4 className="Landing-About-Screenshot-Header-Text">
                                    {image.header}
                                </h4>
                                <p className="Landing-About-Screenshot-Caption-Text">
                                    {image.caption}
                                </p>
                            </div>
                        ))}
                    </div>
                )}
                <div className="Landing-About-Compatibility-Text">
                    {(aboutIOSCompatibility || aboutAndroidCompatibility) && (
                        <p>Compatibility</p>
                    )}
                    {aboutIOSCompatibility && (
                        <p>iPhone: {aboutIOSCompatibility}</p>
                    )}
                    {aboutAndroidCompatibility && (
                        <p>Android: {aboutAndroidCompatibility}</p>
                    )}
                </div>
            </div>
            <div className="Landing-CTA-Container">
                {callToActionHeader && (
                    <h3 className="Landing-CTA-Header-Text">
                        {callToActionHeader}
                    </h3>
                )}
                <div className="Landing-CTA-Body-Text">
                    {callToActionBody && (
                        <SanityBlock blocks={callToActionBody} />
                    )}
                </div>
                {(appleUrl || androidUrl) && (
                    <div className="Landing-CTA-Badge-Container">
                        {appleUrl && (
                            <a href={appleUrl}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/App-Store-Logos/Apple-App-Store-Badge_Black.svg`}
                                    alt="Apple App Store Badge"
                                />
                            </a>
                        )}
                        {androidUrl && <></>}
                    </div>
                )}
            </div>
        </>
    );
}
